
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { connect } from 'react-redux'
import { Document, Page, pdfjs } from 'react-pdf';
import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, Checkbox, Input, Modal, Spin } from 'antd';
import moment from 'moment';
import { useHistory } from "react-router-dom"
import './PDFPreview.css';
import './TextLayer.css';
import { borrower } from '../../Common';
// import "react-pdf/dist/esm/Page/TextLayer.css";

export function blobToURL(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            const base64data = reader.result;
            resolve(base64data);
        };
    });
}

const mapStateToProps = (state) => {
    return {
        hasCoBorrower: state.application.hascoborrower === "withcoborrower",
        application: state.application,
    }
}

// Directly copied from form_marks.go
const signCoordinates = {
	"page3": {
		"borrower.signature":        {Left: 174.713613, Top: 297.660956, Right: 426.297521, Bottom: 322.994476},
		"borrower.signature.date":   {Left: 501.398118, Top: 300.369410, Right: 584.768128, Bottom: 324.006066},
		"coborrower.signature":      {Left: 174.488605, Top: 335.571043, Right: 426.511312, Bottom: 359.054493},
		"coborrower.signature.date": {Left: 501.398118, Top: 332.093102, Right: 583.314695, Bottom: 357.771778},
	},
	"page10": {
		"borrower.signature":        {Left: 169.238363, Top: 698.083528, Right: 426.371229, Bottom: 718.467437},
		"borrower.signature.date":   {Left: 501.722242, Top: 695.090383, Right: 578.803180, Bottom: 717.591487},
		"coborrower.signature":      {Left: 174.377535, Top: 730.113396, Right: 425.773533, Bottom: 751.251198},
		"coborrower.signature.date": {Left: 500.705960, Top: 727.736180, Right: 577.566844, Bottom: 751.094632},
	},
	"page11": {
		"borrower.signature":        {Left: 171.660695, Top: 692.688264, Right: 434.979338, Bottom: 716.316112},
		"borrower.signature.date":   {Left: 499.969273, Top: 692.079133, Right: 590.325586, Bottom: 717.496488},
		"coborrower.signature":      {Left: 173.191246, Top: 724.722401, Right: 427.566627, Bottom: 751.340553},
		"coborrower.signature.date": {Left: 501.973388, Top: 721.516240, Right: 589.782424, Bottom: 751.333549},
	},
	"page13": {
		"borrower.signature":         {Left: 173.764603, Top: 546.621688, Right: 429.373279, Bottom: 570.012715},
		"borrower.signature.date":    {Left: 501.355434, Top: 549.019667, Right: 577.191431, Bottom: 570.918362},
		"coborrower.signature":       {Left: 174.115692, Top: 582.866870, Right: 426.994874, Bottom: 604.855493},
		"coborrower.signature.date":  {Left: 502.355124, Top: 580.538820, Right: 577.404020, Bottom: 605.263537},
	},
}
const PT_PX_RATIO = 1.46

let signMarks = [
    {
        page: 2,
        signid: "page3signature",
        pageName: "page3",
        type: 'signature',
        key: "borrower.signature",
        style: {
        }
    },
    {
        page: 2,
        signid: "page3signature",
        pageName: "page3",
        type: 'date',
        key: "borrower.signature.date",
        style: {
        }
    },
    {
        page: 9,
        signid: "page10signature",
        pageName: "page10",
        type: 'signature',
        key: "borrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 9,
        signid: "page10signature",
        pageName: "page10",
        type: 'date',
        key: "borrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11signature",
        pageName: "page11",
        type: 'signature',
        key: "borrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11signature",
        pageName: "page11",
        type: 'date',
        key: "borrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13signature",
        pageName: "page13",
        type: 'signature',
        key: "borrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13signature",
        pageName: "page13",
        type: 'date',
        key: "borrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
]

let cosignMarks = [
    {
        page: 2,
        signid: "page3cosignature",
        pageName: "page3",
        type: 'signature',
        key: "coborrower.signature",
        style: {
        }
    },
    {
        page: 2,
        signid: "page3cosignature",
        pageName: "page3",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
        }
    },
    {
        page: 9,
        signid: "page10cosignature",
        pageName: "page10",
        type: 'signature',
        key: "coborrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 9,
        signid: "page10cosignature",
        pageName: "page10",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11cosignature",
        pageName: "page11",
        type: 'signature',
        key: "coborrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11cosignature",
        pageName: "page11",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13cosignature",
        pageName: "page13",
        type: 'signature',
        key: "coborrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13cosignature",
        pageName: "page13",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
]

function PDFPreview(props) {
    pdfjs.GlobalWorkerOptions.workerSrc =
        `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const history = useHistory()
    const pageRefs = useRef({});
    const [pdf, setPdf] = useState('');
    const [numPages, setNumPages] = useState(null);
    const [showSignPad, setShowSignPad] = useState(false)
    const [currentSignature, setCurrentSignature] = useState('')
    const [currentSignId, setCurrentSignId] = useState('')
    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [signItems, setSignItems] = useState({})
    const { visible, onClose } = props
    const documentRef = useRef(null);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [signStarted,  setSignStarted] = useState(false)
    const [showRequestConfirmModal, setShowRequestConfirmModal] = useState(false)
    const [codeConsent, setCodeConsent] = useState(false)
    const [passcode, setPasscode] = useState('')
    const [sendingSignRequest, setSendingSignRequest] = useState(false)
    const containerRef = useRef(null)
    const WIDTH = 900
    const [form] = Form.useForm()

    const onPageLoadSuccess = (page) => {
    };

    /*To Prevent right click on screen*/
    document.addEventListener("contextmenu", (event) => {
        event.preventDefault();
    });

    function insertSignature() {
        const foundList = signMarks.filter(x => x.signid === currentSignId)
        let newSignItems = JSON.parse(JSON.stringify(signItems))
        for (const { pageName, key, type } of foundList) {
            if (type === 'signature') {
                newSignItems[pageName][key] = form.getFieldValue("signature")
            } else if (type === 'date') {
                newSignItems[pageName][key] = moment().format("MM/DD/YYYY")
            }
        }
        setSignItems(newSignItems)
        setCurrentSignId("")
        setShowSignPad(false)
    }

    /*When document gets loaded successfully*/
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function verifySignItems(signItems) {
        for (const pageName in signItems) {
            for (const key in signItems[pageName]) {
                if (!signItems[pageName][key]) return [pageName, key]
            }
        }
        return true
    }

    function hasNextSign() {
        const verifyResult = verifySignItems(signItems)
        return Array.isArray(verifyResult)
    }

    function scrollNextSign() {
        const verifyResult = verifySignItems(signItems)
        if (Array.isArray(verifyResult)) {
            const [pageName, key] = verifyResult
            let found = signMarks.find(x => x.pageName === pageName && key === key)
            if (found && containerRef.current && pageRefs.current) {
                let pageOffset = pageRefs.current[found.page]?.offsetTop || 0
                containerRef.current.scrollTop = found.style.top + pageOffset - 50
            }
            return
        }
    }



    function onSubmit() {
        setSubmitLoading(true)

        let token = sessionStorage.getItem("ZeitroA")
        fetch('/borrower/hardmoneyloan/generateforms', {
          method: 'POST',
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
          },
          body: JSON.stringify({signItems})
        }).then(
          response => {
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' +
                response.status);
                setSubmitLoading(false)
              return;
            }

            setSubmitLoading(false)
            setShowRequestConfirmModal(false)
            props.onSubmit(signItems)
          }
        )
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
          });
    }

    function showSignRequestModal() {
        if (props.hasCoBorrower) {
            //geneerate 4 digit random code and send email to main and co borrower
            // emailSignRequest()
            setSignStarted(true)
            scrollNextSign()
        } else {
            setSignStarted(true)
            scrollNextSign()
        }
    }

    function openSignPad(signid) {
        setCurrentSignId(signid)
        setShowSignPad(true)
    }

    function emailSignRequest() {
        setSendingSignRequest(true)
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/borrower/hardmoneyloan/sendpasscodeandinvitecosigner', {
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                borrowerEmail: props.application.borrower.email.toLowerCase(),
                coborrowerEmail: props.application.coborrower.email.toLowerCase(),
                borrowerFirstName: props.application.borrower.firstname,
                borrowerLastName: props.application.borrower.lastname,
                coborrowerFirstName: props.application.coborrower.firstname,
                coborrowerLastName: props.application.coborrower.lastname,
            }),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        }).then(res => {
            if (res.status !== 200) {
                alert("Looks like there was a problem. Status Code: " + res.status +", please try again later or contact your loan officer for assistance.")
                setSendingSignRequest(false)
                return;
            }
            res.json().then(js => {
                setPasscode(js.Code)
                setSendingSignRequest(false)
                setShowRequestConfirmModal(true)
                return
            })
        })
      
    }

    useEffect(() => {
        if (visible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [visible])


    useEffect(async () => {
        setLoading(true)

        if (props.hasCoBorrower) {
            signMarks = [
                ...signMarks,
                // ...cosignMarks,
            ]
        }

        for (const signMark of signMarks) {
            const { pageName, key } = signMark
            signMark.style = {
                top: signCoordinates[pageName][key].Top * PT_PX_RATIO,
                left: signCoordinates[pageName][key].Left * PT_PX_RATIO,
                width: (signCoordinates[pageName][key].Right - signCoordinates[pageName][key].Left) * PT_PX_RATIO,
                height: (signCoordinates[pageName][key].Bottom - signCoordinates[pageName][key].Top) * PT_PX_RATIO,
            }
        }

        let initSignItems = {}
        for (const { pageName, key, type } of signMarks) {
            if (!(pageName in initSignItems)) {
                initSignItems[pageName] = {}
            }
            if (!(key in initSignItems[pageName])) {
                initSignItems[pageName][key] = ''
            }
        }
        setSignItems(initSignItems)
        let token = sessionStorage.getItem("ZeitroA")

        const existingPdfBytes = await fetch('/borrower/hardmoneyloan/previewyeeleeform', {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        }).then(res => res.arrayBuffer()).catch(function (err) {
            console.log('Fetch Error :-S', err);
        });
        const blob = new Blob([new Uint8Array(existingPdfBytes)]);

        const URL = await blobToURL(blob);
        setPdf(URL);
        setLoading(false)
    }, []);

    const renderRequestConfirmModal = () =>
        <Modal
            open={showRequestConfirmModal}
            closable={false}
            className="request-confirm-modal"
            footer={
                <Button
                    className={codeConsent ? 'confirmBtn' : 'confirmBtnDisabled'}
                    type="primary" 
                    disabled={!codeConsent} 
                    loading={submitLoading}
                    onClick={
                        () => {
                            onSubmit()
                        }
                    }
                >
                    Submit my signatures
                </Button>
            }
        >
            <div className="request-confirm-wrap">
                <div className='request-confirm-title bottomSpaceAdjuster'>
                    <div>Co-borrower signature requested</div>
                    <img src="/images/sendingEmail.png"/>
                </div>
                <p className='bottomSpaceAdjuster'>{`We have sent a signature request email to your co-borrower, ${props.application.coborrower.firstname +" "+ props.application.coborrower.lastname} [${props.application.coborrower.email}].`}</p>
                <p className='bottomSpaceAdjuster'>Please securely share the <span>4-digit verification code</span> below with your co-borrower, so they can access the application form. </p>
                <div className="verification-code bottomSpaceAdjuster">
                    <span>{passcode}</span>
                </div>
                <p className='bottomSpaceAdjuster'>This code is used to ensure the security of your sensitive data. You can also find this verification code in your email. </p>
                <p className='bottomSpaceAdjuster'>Once all signatures are received, the application will be submitted automatically. </p>
                <Checkbox className='bottomSpaceAdjuster' onChange={(e) => setCodeConsent(e.target.checked)}>I understand that I need to share the verificatin code with my co-borrower</Checkbox>
            </div>
        </Modal>

    const renderSignPad = () =>
        <Modal
            open={showSignPad}
            closable={false}
            className="sign-pad"
            title="Please type your name"
            footer={null}
        >
            <Form
                form={form}
                name='sign-pad'
                onFinish={insertSignature}
            >
                <Form.Item
                    name="signature"
                    rules={[{ required: true, message: 'Please sign your name' }]}
                >
                    <Input
                        className="signature"
                        style={{
                            height: 42,
                            lineHeight: '26px',
                            fontSize: 26,
                            fontFamily: 'smooch',
                            padding: 8,
                            borderRadius: 0,
                            border: '1px solid #325CEB',
                        }}
                        // onChange={onCurrentSignature}
                    />
                </Form.Item>
                <Form.Item
                    name="consent"
                    valuePropName="checked"
                    style={{ textAlign: 'left' }}
                    rules={[{ required: true, message: 'Please select the checkbox' }]}
                >
                    <Checkbox>I agree to electronically sign this document, understand this is a legal
                        representation of my signature, and agree to the <a className='signature-terms-link' onClick={() => setIsModalOpen(true)}>electronic signature terms</a>.</Checkbox>
                </Form.Item>

                <div className="action-button-group">
                    <Form.Item>
                        <Button
                            className="cancel-button"
                            onClick={() => {
                                setShowSignPad(false)
                                setCurrentSignId("")
                            }}
                        >Cancel</Button>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType='submit' className="insert-button">Insert</Button>
                    </Form.Item>
                </div>
            </Form>
            <Modal
                title="Electronic Signature Terms"
                className='signature-terms-modal'
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={[<Button type="primary" onClick={() => setIsModalOpen(false)}>Got it</Button>]}
            >
                <p>By using the electronic signature feature on this website, you agree to the legal validity and binding nature of your electronic signature on Yeelee Capital loan application forms. Yeelee Capital reserves the right to implement authentication measures to verify the identity of the applicant when using electronic signatures.
You can withdraw consent by notifying Yeelee Capital in writing, but this may affect your loan application.We will retain electronic signature records as required by law.
You can request a copy of your signed documents.Yeelee Capital may update these terms. Continued use of electronic signatures implies acceptance of any changes.By using our electronic signature feature, you confirm your understanding and acceptance of these terms.</p>
            </Modal>
        </Modal>

    return (
        <>
            <div className="pdf-preview-main" style={{ display: visible ? 'block' : 'none' }}>
                <div className="top-nav">
                    <div>Please follow the instruction to provide your signatures and then click Submit.</div>
                    <CloseOutlined
                        onClick={onClose}
                        className="close-icon"
                    />
                </div>
                <center className="pdf-container" ref={containerRef}>
                {!loading ? <Document
                        className="pdf-content"
                        file={pdf}
                        ref={documentRef}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        {Array.from(
                            new Array(numPages),
                            (el, index) => (
                                <Page
                                    inputRef={ref => {
                                        pageRefs.current[index] = ref;
                                    }}
                                    width={WIDTH}
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    renderTextLayer={false}
                                    onLoadSuccess={onPageLoadSuccess}
                                    onRenderSuccess={(props) => {

                                    }}
                                >
                                    <div
                                        className="page-sign-layer"
                                        style={{
                                            width: WIDTH,
                                            marginLeft: -WIDTH / 2,
                                            left: '50%',
                                        }}
                                    >
                                        {signMarks.map((signMark, signIdx) => {
                                            if (signMark.page === index) {
                                                let signContent = signItems[signMark.pageName][signMark.key]
                                                if (signMark.type === 'signature') {
                                                    return <>
                                                        <div
                                                            key={signMark.key}
                                                            className="sign-mark"
                                                            onClick={() => openSignPad(signMark.signid)}
                                                            style={{
                                                                position: 'absolute',
                                                                ...signMark.style
                                                            }}
                                                        >
                                                            {signContent}
                                                        </div>
                                                        {!signStarted? null : !signContent ? <div
                                                            className='sign-thumb-wrapper'
                                                            onClick={() => openSignPad(signMark.signid)}
                                                        >
                                                            <div
                                                                className='sign-thumb'
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: signMark.style.top,
                                                                    left: -140,
                                                                }}
                                                            >
                                                                Sign Here
                                                            </div>
                                                            <div
                                                                className="sign-thumb-triangle"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: signMark.style.top,
                                                                    left: -40,
                                                                }}
                                                            ></div>
                                                        </div> : null}
                                                    </>
                                                } else if (signMark.type === 'date') {
                                                    return (
                                                        <div
                                                            key={signMark.key}
                                                            className={signMark.type === 'signature' ? "sign-mark" : "sign-mark-date"}
                                                            onClick={() => openSignPad(signMark.signid)}
                                                            style={{
                                                                position: 'absolute',
                                                                ...signMark.style
                                                            }}
                                                        >
                                                            {signContent}
                                                        </div>
                                                    )
                                                }
                                            }
                                            return null;
                                        })}
                                    </div>
                                </Page>
                            )
                        )}
                    </Document>: <div className="spin-wrapper"> <Spin size='large'/><div className="mt-3">Generating application PDF form...</div></div>}
                </center>

                {renderSignPad()}
                {renderRequestConfirmModal()}
                <div className="bottom-nav">
                    <Button
                        type="default"
                        disabled={loading}
                        onClick={onClose}
                        className='submit-btn'
                    >
                        Back to edit
                    </Button>
                    <Button
                        type="primary"
                        disabled={loading}
                        loading={submitLoading}
                        className='submit-btn'
                        onClick={signStarted? (hasNextSign() ? scrollNextSign : props.hasCoBorrower? emailSignRequest : onSubmit) : showSignRequestModal}
                    >
                        {sendingSignRequest? <Spin/>:(signStarted?(hasNextSign() ? 'Next' :props.hasCoBorrower? 'Invite Co-borrower' : 'Submit') : 'Proceed to sign')}
                    </Button>
                </div>
            </div>
        </>
    );
}

export default PDFPreview = connect(mapStateToProps)(PDFPreview);
